import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { IconButton } from "@mui/material";
import { StyledInput, AddFileImage, DisabledIconButton } from "./styled";
import { attachIcon } from "@/shared/assets/images";
const FileUploader = ({ handleFileChange, filesAmount }) => {
    const isDisabled = filesAmount === 5;
    return (isDisabled ? (_jsxs(DisabledIconButton, { size: "small", color: "purple", disabled: true, children: [_jsx(AddFileImage, { src: attachIcon }), _jsx(StyledInput, { type: "file", accept: ".doc,.docx,.txt,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.pdf", onChange: handleFileChange, disabled: true })] })) : (_jsxs(IconButton, { size: "small", color: "purple", component: "label", children: [_jsx(AddFileImage, { src: attachIcon }), _jsx(StyledInput, { type: "file", accept: ".doc,.docx,.txt,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.pdf", onChange: (event) => {
                    handleFileChange(event);
                    event.target.value = "";
                } })] })));
};
export default FileUploader;
